<script setup>
/* Imports */
import { computed } from 'vue';

/* Props */
const props = defineProps({
  pricingData: {
    type: Object,
    default: () => {},
  },
  priceIsLoading: {
    type: Boolean,
    default: true,
  },
});

/* DataTestId */
const dataTestId = {
  price: {
    host: 'price',
    originalPrice: {
      wrapper: 'original-price-wrapper',
      fromText: 'from-text',
      value: 'original-price-value',
      savingsText: 'original-price-savings',
    },
    discountedPrice: {
      wrapper: 'discounted-price-wrapper',
    },
    detailsText: 'details-text',
    andUpText: 'and-up-text',
  },
  // Add more data test ids here for the GC
};

/* Prices */
const listPrice = computed(() => (props.pricingData?.listPrice ? props.pricingData.listPrice : ''));
const salePrice = computed(() => (props.pricingData?.salePrice ? props.pricingData.salePrice : ''));
const hasDiscount = computed(() => {
  if (props.pricingData?.unformatted) {
    return props.pricingData.unformatted?.listPrice
        > props.pricingData.unformatted?.salePrice;
  }

  return false;
});
const hasPrice = computed(() => props.pricingData?.listPrice || props.pricingData?.salePrice);
const discountedPrice = computed(() => (hasDiscount.value ? salePrice.value : undefined));
const hasPricingTextBefore = computed(() => (props.pricingData?.andUpText && props.pricingData?.andUpText.endsWith('{0}')));
const pricingText = computed(() => (props.pricingData?.andUpText ? props.pricingData.andUpText.replace('{0}', '') : ''));
</script>

<template>
  <div
    v-if="props.priceIsLoading"
    class="price__loader"
  >
    <g-loader type="default" />
  </div>
  <div v-else>
    <template v-if="hasPricingTextBefore && hasPrice">
      <div
        class="price-from-text"
      >
        {{ pricingText }}
      </div>
      <g-price
        class="price"
        :original-price="listPrice"
        :discounted-price="discountedPrice"
        :has-text="true"
        :dataTestId="dataTestId.price"
      />
    </template>
    <template v-else-if="hasPrice">
      <g-price
        class="price"
        :original-price="listPrice"
        :discounted-price="discountedPrice"
        :has-text="true"
        :and-up-text="pricingText"
        :dataTestId="dataTestId.price"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.price {
  flex-direction: column;

  &__loader {
    max-width: 6rem;
    margin-bottom: 2rem;
  }
}
</style>

<style lang="scss">
// Global component overrides

.price[has-text = 'true'] {

  .g__price__original-price,
  .g__price__discounted-price {
    flex-direction: column;
  }
}

.g__price .and-up-text {
  margin-left: 0;
}
</style>
